import type { DialogSummary } from "@/lib/inbox";

/**
 * Human-readable peer name for a dialog: full name → @username → #tg_id.
 * Shared by the dialog list and the conversation header so InboxPage and
 * InboxDrawer render identical labels.
 */
export function peerDisplayName(dialog: DialogSummary): string {
  const full = [dialog.peer_first_name, dialog.peer_last_name]
    .filter(Boolean)
    .join(" ")
    .trim();
  if (full) return full;
  if (dialog.peer_username) return `@${dialog.peer_username}`;
  return `#${dialog.peer_tg_id}`;
}
